import {gql, useLazyQuery} from "@apollo/client";
import { useLogger } from "./useLogger";

const QUERY = gql`
query getBlockBuyingSharesDialogContent(
  $countryCode: String!
  $targetPage: String!
  $locale: String!
) {
  blockBuyingSharesDialogCollection(
    limit: 1
    where: {
      targetCountry: { countryCode: $countryCode }
      targetPage_contains_some: [$targetPage]
    }
    locale: $locale
  ) {
    items {
      image {
        url
        title
      }
      title
      description {
        json
      }
      ctaButtonTargetPageDirectSales {
        ... on Button {
          label
          url
        }
      }
      ctaButtonTargetPageMarketplace {
        ... on Button {
          label
          url
        }
      }
    }
  }
}`;

export const useBlockBuyingSharesDialogContent = () => {
    const {logger} = useLogger();
    const [getBlockBuyingSharesDialogContent, {
        data,
        error
    }] = useLazyQuery(QUERY, {
        fetchPolicy: "network-only",
        errorPolicy: "all"});

    const targetPages = {
        direct_sale: "Direct Sales",
        marketplace: "Marketplace"
    };

    if (error?.message) {
        logger(error?.message, "error", "getBlockBuyingSharesDialogContent", error?.stack);
    }

    const fetchBlockingBuyingSharesDialogContent = async (countryCode, targetPage, locale) => {
        if (countryCode && targetPage && locale) {
            const response = await getBlockBuyingSharesDialogContent({
                variables: { countryCode, targetPage, locale }
            });
            return response?.data?.blockBuyingSharesDialogCollection?.items?.[0];
        }
        return null;
    };

    return {
        fetchBlockingBuyingSharesDialogContent,
        blockingBuyingSharesDialogContentDetails: data?.blockBuyingSharesDialogCollection?.items?.[0],
        targetPages
    };
};
